import React from "react";
import { ProductItem } from "../../../domain/entities/ProductItem";
import { useNavigate } from "react-router-dom";
import iconRegistrasi from "../../../assets/Form/ic_white_register.png";

const API_URL = process.env.REACT_APP_IMAGE_URL || "";

interface ProductItemListProps {
  productItem: ProductItem;
}

const ProductItemList: React.FC<ProductItemListProps> = ({ productItem }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (productItem.category.slug === 'sudirman-park') {
      navigate("/register-sudirman-park");
    } else {
      navigate("/register");
    }
  };

  // Create the complete image URL
  const backgroundImageUrlDesktop = productItem.path ? `${API_URL}${productItem.path}` : "";
  const backgroundImageUrlApp = productItem.path ? `${API_URL}${productItem.path_apps}` : "";
  const isMobile = window.innerWidth < 768;

  return (
    <div
      className={`
        flex items-center justify-end 
        bg-white border border-gray-200 rounded-xl shadow-md 
        w-full bg-no-repeat bg-cover md:bg-center
      `} // Increased height for mobile
      style={{
        backgroundImage: `url(${isMobile ? backgroundImageUrlApp : backgroundImageUrlDesktop})`
      }}
    >
      <div className="flex-shrink-0 mx-2.5 mt-20 mb-2 md:m-10 lg:m-12">
        <button
          className="bg-[#9b284c] text-white text-xs rounded-lg px-2.5 py-1.5 md:px-4 md:py-2 font-bold hover:bg-[#801d3e] transition-all flex items-center gap-1 font-poppins"
          onClick={handleButtonClick}
        >
          <img src={iconRegistrasi} alt="Icon Registrasi" className="w-2 h-2 md:w-4 md:h-4" />
          <span>Registrasi</span>
        </button>
      </div>
    </div>
  );
};

export default ProductItemList;